import React, { createContext, useContext, useState, useEffect } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

const USER_KEY = "tavoline.staff_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      let savedUser = null;
      try { savedUser = JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch {}
      const token = localStorage.getItem(TOKEN_KEY);
      if (savedUser && token) {
        try {
          const fresh = await api.me();
          setUser(fresh);
        } catch {
          setUser(savedUser);
        }
      }
      setReady(true);
    })();
  }, []);

  const login = async (email, password) => {
    const res = await api.login(email, password);
    localStorage.setItem(TOKEN_KEY, res.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify(res.user));
    setUser(res.user);
    return res.user;
  };

  const logout = async () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
